import React, { useState, useEffect } from "react";

// ATTENTION!!!!!!!!!!
// I SWITCHED TO PERMANENT DOMAIN

const Tour = () => {
  const url = "https://course-api.com/react-tours-project";
  const [data, setData] = useState([]);
  const [expandedId, setExpandedId] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = () => {
    setIsLoading(true);
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  function deleteTour(id) {
    setData(data.filter((tour) => tour.id !== id));
  }

  function refreshTours() {
    fetchData();
  }

  return (
    <main>
      <section>
        <div className="title">
          {isLoading ? (
            <h2>Loading</h2>
          ) : data.length ? (
            <div>
              <h2>Our Tours</h2>
              <div className="underline"></div>
            </div>
          ) : (
            <>
              <h2>No Tours left</h2>
              <button onClick={refreshTours} className="btn">
                Refresh
              </button>
            </>
          )}
        </div>

        <div className="tours">
          {data.map((tour) => {
            const { id, image, name, price, info } = tour;

            return (
              <article key={id} className="single-tour">
                <img src={image} alt="" />
                <div className="tour-info">
                  <h4 className="tour-price">{price}</h4>
                  <h4>{name}</h4>
                  <p>
                    {expandedId === id ? info : info.slice(0, 50) + "..."}
                    {expandedId === id ? (
                      <button onClick={() => setExpandedId(null)}>
                        Read less
                      </button>
                    ) : (
                      <button onClick={() => setExpandedId(id)}>
                        Read more
                      </button>
                    )}
                  </p>
                  <button onClick={() => deleteTour(id)} className="btn">
                    Not interested
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default Tour;
